module.exports = "https://img.xiyuyouxi.com/saas/img/guid_icon.79872798.png";